<template>
  <div class="expansion-panel" :class="{ 'expansion-panel--active': value }">
    <label class="expansion-panel__label max-md:!mb-2" :tabindex="disabled ? -1 : 0" @click="toggle">
      <slot name="title">
        <div class="expansion-panel__label-text" :class="titleClass">
          <UIIcon
            v-if="!hideIconBefore"
            name="chevron-big-right-circle-outlined"
            class="expansion-panel__label-toggle-icon"
            :class="{ 'expansion-panel__label-toggle-icon--rotated': value }"
          />
          <span>{{ title }}</span>
        </div>
        <UIIcon
          v-if="icon"
          :name="icon"
          class="expansion-panel__label-icon base-transition duration-200"
          :class="{ 'rotate-180': value && showIconAfter }"
          @click.stop="emit('icon-click')"
        />
      </slot>
    </label>

    <Collapse :when="value!" class="expansion-panel__content height-transition">
      <slot />
    </Collapse>
  </div>
</template>

<script setup lang="ts">
import { Collapse } from 'vue-collapsed'

const value = defineModel<boolean>('modelValue', { default: true })

const props = defineProps<{
  modelValue?: boolean
  title: string
  disabled?: boolean
  showIconAfter?: boolean
  hideIconBefore?: boolean
  icon?: string
  titleClass?: string
}>()

const emit = defineEmits<{
  (e: 'icon-click'): void
}>()

const toggle = () => {
  if (props.disabled) return

  value.value = !value.value
}
</script>

<style scoped lang="scss">
@import '@/styles/mixins.scss';
.expansion-panel {
  width: 100%;

  &__label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: $base-transition margin;
    @include subhead1();

    &-text {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &-toggle-icon {
      transition: $base-transition all;
      transform: rotate(-180deg);

      &--rotated {
        transform: rotate(0);
      }
    }

    &-icon {
      flex-shrink: 0;
      color: $black-70;
    }
  }

  &--active {
    .expansion-panel {
      &__label {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
